import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container mx-auto pt-8 pb-16 px-4" }
const _hoisted_2 = { class: "text-gray-100 text-3xl font-semibold pt-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "bg-white text-gray-700 p-4 mt-8 rounded-md shadow-md" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 text-sm" }, "Date range:", -1)
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "inline-flex items-center px-3 border border-r-0 rounded-l-md border-gray-200 bg-gray-50 text-gray-500 text-sm" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 text-sm" }, "Absence type:", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "mt-4" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-sm" }, "Open absence", -1)
const _hoisted_19 = {
  key: 0,
  class: "min-w-full mt-8 border overflow-hidden border-b border-gray-200 rounded-md"
}
const _hoisted_20 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "px-4 py-3 text-left font-medium text-gray-800"
    }, "Absence days")
  ])
], -1)
const _hoisted_22 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_23 = { class: "px-2 py-3 whitespace-nowrap border-r" }
const _hoisted_24 = { class: "flex align-middle items-center" }
const _hoisted_25 = { class: "mx-2 text-xs font-semibold text-center p-1 rounded-md text-indigo-600 bg-indigo-100" }
const _hoisted_26 = {
  width: "250px",
  style: {"max-width":"250px"},
  class: "px-2 whitespace-nowrap"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-sm" }, "Part", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "flex-stretch w-16" }, null, -1)
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = ["onUpdate:modelValue", "readonly"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-1 border border-r-0 border-l-0 border-gray-200 bg-gray-50 text-gray-500 text-sm" }, "h", -1)
const _hoisted_36 = ["onUpdate:modelValue", "readonly"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-1 border rounded-r-md border-gray-200 bg-gray-50 text-gray-500 text-sm" }, "m", -1)
const _hoisted_38 = { class: "flex mt-4 justify-end" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, "Save absence", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      (_ctx.absenceID)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Edit Absence"))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, "New Absence"))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Loading. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_date_picker, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
              masks: {input: 'D. M. YYYY'},
              popover: { visibility: 'focus' },
              "is-range": ""
            }, {
              default: _withCtx(({ inputValue, inputEvents, isDragging }) => [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_CalendarIcon, { class: "h-5 w-5" })
                    ]),
                    _createElementVNode("input", _mergeProps({
                      readonly: "",
                      class: ["flex-grow px-3 py-2 w-full rounded-md rounded-l-none border border-gray-200 text-sm text-gray-700", isDragging ? 'text-gray-500' : 'text-gray-700'],
                      value: _ctx.date.start && _ctx.date.end ? (inputValue.start + ' - ' + inputValue.end) : 'Select range'
                    }, _toHandlers(inputEvents.start)), null, 16, _hoisted_12)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "masks"]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedAbsenceType) = $event)),
                class: "form-select appearance-none w-full rounded-md text-sm text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-200"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.absenceTypes, (absenceType) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: absenceType.id,
                    value: absenceType.id
                  }, [
                    _createElementVNode("span", null, _toDisplayString(absenceType.name), 1)
                  ], 8, _hoisted_15))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedAbsenceType]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.open) = $event)),
                  type: "checkbox",
                  class: "form-checkbox rounded-sm focus:ring-0 border-gray-300"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.open]
                ]),
                _hoisted_18
              ])
            ]),
            (_ctx.days.size > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("table", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("tbody", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, ([date, day]) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: date,
                          class: "hover:bg-gray-50"
                        }, [
                          _createElementVNode("td", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.formatDate(new Date(date))), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_26, [
                            (day.hasTimePart)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("label", _hoisted_29, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((day.enabled) = $event),
                                        type: "checkbox",
                                        class: "form-checkbox rounded-sm focus:ring-0 border-gray-300"
                                      }, null, 8, _hoisted_30), [
                                        [_vModelCheckbox, day.enabled]
                                      ]),
                                      _hoisted_31
                                    ]),
                                    _hoisted_32,
                                    _createElementVNode("div", _hoisted_33, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((day.time.hours) = $event),
                                        readonly: !day.enabled,
                                        type: "text",
                                        inputmode: "numeric",
                                        onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select())),
                                        class: _normalizeClass(["w-full rounded-l-md border-gray-200 text-sm text-gray-700 px-1 text-center", !day.enabled && 'bg-gray-100'])
                                      }, null, 42, _hoisted_34), [
                                        [
                                          _vModelText,
                                          day.time.hours,
                                          void 0,
                                          { number: true }
                                        ]
                                      ]),
                                      _hoisted_35,
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((day.time.minutes) = $event),
                                        readonly: !day.enabled,
                                        type: "text",
                                        inputmode: "numeric",
                                        onFocus: _cache[4] || (_cache[4] = ($event: any) => ($event.target.select())),
                                        class: _normalizeClass(["w-full border-gray-200 border-r-0 text-sm text-gray-700 px-1 text-center", !day.enabled && 'bg-gray-100'])
                                      }, null, 42, _hoisted_36), [
                                        [
                                          _vModelText,
                                          day.time.minutes,
                                          void 0,
                                          { number: true }
                                        ]
                                      ]),
                                      _hoisted_37
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_app_button, {
                onClick: _ctx.onSubmit,
                type: "blue",
                class: _normalizeClass(['w-full sm:w-auto'])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CheckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                  _hoisted_39
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
    ])
  ]))
}